<template>
  <div class="star-rating" :style="{ color: starStyle.indicatorColor }">
    <div
      class="star-container"
      v-for="(star, index) in stars"
      :key="index"
      :style="[{ cursor: interacted || interacted === 0 ? 'auto' : 'pointer' }, { borderBottom: showResults && interacted === index ? '3px solid ' + starStyle.fullStarColor : '3px solid #0000' }]"
      @mouseenter="mouseenter($event, index)"
      @mouseleave="mouseleave($event, index)"
      @click="clicked($event, index)">
      <svg class="star-svg" :class="{ 'star-svg--finished': interacted || interacted === 0 }" :style="[{ fill: `url(#gradient${star.raw})` }, { maxWidth: styleStarWidth }, { maxHeight: styleStarHeight }]">
        <polygon :points="getShapePoints" style="fill-rule: nonzero" />
        <defs>
          <linearGradient :id="`gradient${star.raw}`">
            <stop id="stop1" :offset="star.percent" stop-opacity="1" :stop-color="getFullFillColor(star)"></stop>
            <stop id="stop2" :offset="star.percent" stop-opacity="0" :stop-color="getFullFillColor(star)"></stop>
            <stop id="stop3" :offset="star.percent" stop-opacity="1" :stop-color="styleEmptyStarColor"></stop>
            <stop id="stop4" offset="100%" stop-opacity="1" :stop-color="styleEmptyStarColor"></stop>
          </linearGradient>
        </defs>
      </svg>
      <div class="avatar-indicator-container" v-if="typeShowResults && isInteractionsRoute && (interacted || interacted === 0) && interacted == index">
        <img class="rounded-avatar-small-img" :src="$store.state.user.picture" :alt="$store.state.user.name" />
        <span class="user-rate-overlay">{{ index + 1 }}</span>
      </div>
    </div>
    <div v-if="!showResults && userRating !== 0 && userRating !== 'hidden'" class="indicator">{{ userRating }}</div>
    <div v-if="!showResults && userRating === 0 && (interacted || interacted === 0)" class="indicator">{{ (interacted + 1).toFixed(1) }}</div>
    <div v-if="typeShowResults && showResults && globalRating" class="indicator">{{ globalRating.toFixed(1) }}</div>
  </div>
</template>

<script>
export default {
  name: 'stars-rating',
  props: {
    globalRating: {
      type: Number,
      default: 0.0,
    },
    starStyle: {
      type: Object,
      default: () => ({
        fullStarColor: '#ed8a19',
        emptyStarColor: '#737373',
        starWidth: 80,
        starHeight: 80,
      }),
    },
    isIndicatorActive: {
      type: Boolean,
      default: true,
    },
    totalStars: {
      type: Number,
      default: 5,
    },
    options: {
      type: Array,
      default: () => [],
    },
    typeShowResults: {
      type: Boolean,
      default: false,
    },
    showResults: {
      type: Boolean,
      default: false,
    },
    interacted: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      stars: [],
      emptyStar: 0,
      fullStar: 1,
      styleStarWidth: 100,
      styleStarHeight: 100,
      styleEmptyStarColor: 'gray',
      styleFullStarColor: 'goldenrod',
      isMobile: false,
      isMouseOver: false,
      userRating: null,
      windowWidth: null,
      finished: false,
    };
  },
  computed: {
    getShapePoints() {
      let centerX = this.styleStarWidth / 2;
      let centerY = this.styleStarHeight / 2;

      let innerCircleArms = 5;

      let innerRadius = this.styleStarWidth / innerCircleArms;
      let innerOuterRadiusRatio = 2.3; // Unique value - determines fatness/sharpness of star
      let outerRadius = innerRadius * innerOuterRadiusRatio;

      return this.calcStarPoints(centerX, centerY, innerCircleArms, innerRadius, outerRadius);
    },
    isInteractionsRoute() {
      return this.$route.name === 'Interactions';
    },
  },
  methods: {
    calcStarPoints(centerX, centerY, innerCircleArms, innerRadius, outerRadius) {
      let angle = Math.PI / innerCircleArms;
      let angleOffsetToCenterStar = 60;

      let totalArms = innerCircleArms * 2;
      let points = '';
      for (let i = 0; i < totalArms; i++) {
        let isEvenIndex = i % 2 == 0;
        let r = isEvenIndex ? outerRadius : innerRadius;
        let currX = centerX + Math.cos(i * angle + angleOffsetToCenterStar) * r;
        let currY = centerY + Math.sin(i * angle + angleOffsetToCenterStar) * r;
        points += currX + ',' + currY + ' ';
      }
      return points;
    },
    initStars() {
      for (let i = 0; i < this.totalStars; i++) {
        this.stars.push({
          raw: this.emptyStar,
          percent: this.emptyStar + '%',
        });
      }
    },
    setRatedStars() {
      this.userRating = 0;
      let fullStarsCounter = this.typeShowResults || this.showResults ? Math.floor(this.globalRating) : this.interacted + 1;
      for (let i = 0; i < this.stars.length; i++) {
        if (fullStarsCounter !== 0) {
          this.stars[i].raw = this.fullStar;
          this.stars[i].percent = this.calcStarFullness(this.stars[i]);
          fullStarsCounter--;
        } else {
          let usedRating = this.showResults ? this.globalRating : this.interacted + 1;
          let surplus = Math.round((usedRating % 1) * 10) / 10;
          let roundedOneDecimalPoint = Math.round(surplus * 10) / 10;
          this.stars[i].raw = roundedOneDecimalPoint;
          return (this.stars[i].percent = this.calcStarFullness(this.stars[i]));
        }
      }
    },
    getFullFillColor(starData) {
      return starData.raw !== this.emptyStar ? this.styleFullStarColor : this.styleEmptyStarColor;
    },
    calcStarFullness(starData) {
      let starFullnessPercent = starData.raw * 100 + '%';
      return starFullnessPercent;
    },
    setNestedConfigStyles(objToFlatten) {
      if (typeof objToFlatten === 'object') {
        for (let i in objToFlatten) {
          let newKey = 'style' + i.charAt(0).toUpperCase() + i.substring(1, i.length);
          this[newKey] = objToFlatten[i];
        }
      }
    },
    clicked(e, idx) {
      // this.mouseenter(e, idx);
      this.finished = true;
      this.$emit('clicked', idx);
    },
    mouseenter(e, idx) {
      if (this.finished || this.interacted || this.interacted === 0) return;
      this.userRating = idx + 1;
      this.isMouseOver = true;
      this.stars[idx].raw = this.fullStar;
      this.stars[idx].percent = this.calcStarFullness(this.stars[idx]);
      for (let i = 0; i < idx; i++) {
        this.stars[i].raw = this.fullStar;
        this.stars[i].percent = this.calcStarFullness(this.stars[i]);
      }
    },
    mouseleave(e, idx) {
      if (this.finished || this.interacted || this.interacted === 0) return;
      this.userRating = ' ';
      this.stars.map((star) => {
        star.raw = this.emptyStar;
        star.percent = this.calcStarFullness(star);
      });

      this.isMouseOver = false;
      // run this.setRatedStars only if the mouse is not over the stars for at least 3 seconds
      if (this.globalRating) {
        setTimeout(() => {
          if (!this.isMouseOver) {
            if (this.showResults) this.setRatedStars();
          }
        }, 1000);
      }
    },
    resize() {
      this.windowWidth = window.innerWidth;
      if (this.windowWidth < 486) {
        if (!this.isMobile) {
          this.styleStarWidth = this.starStyle.starWidth / 2;
          this.styleStarHeight = this.starStyle.starHeight / 2;
          this.isMobile = true;
        }
      } else {
        this.styleStarWidth = this.starStyle.starWidth;
        this.styleStarHeight = this.starStyle.starHeight;
        this.isMobile = false;
      }
    },
  },
  beforeMount() {
    this.setNestedConfigStyles(this.starStyle);
    this.initStars();
    if (this.interacted || this.interacted === 0) this.setRatedStars();
  },
  mounted() {
    this.resize();
    window.addEventListener('resize', this.resize);
  },
  updated() {
    if (this.interacted || this.interacted === 0) this.setRatedStars();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize);
  },
};
</script>

<style scoped lang="scss">
.star-rating {
  display: flex;
  align-items: center;
  justify-content: center;
  .star-container {
    position: relative;
    display: flex;
    cursor: pointer;

    .star-svg {
      width: 100%;
      height: auto;
      transition: all 0.1s ease-in-out;

      &:hover:not(.star-svg--finished) {
        transform: scale(1.1);
      }
    }

    .avatar-indicator-container {
      position: absolute;
      inset: auto;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      pointer-events: none;
      opacity: 0.83;

      .rounded-avatar-small-img {
        max-width: 36px;
        max-height: 36px;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        object-fit: cover;
      }
      .user-rate-overlay {
        position: absolute;
        inset: 28px auto auto;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        pointer-events: none;
        font-size: 1rem;
        font-weight: bolder;
      }
    }
  }
  .indicator {
    font-size: 2rem;
    font-weight: bolder;
    min-width: 60px;
    text-align: center;
  }
}
</style>
